<template>
  <v-dialog v-model="dialog" max-width="500px" @keydown.esc="close">
    <v-card>
      <v-card-title>{{ $t('userManagement.deleteDialog.title') }}</v-card-title>
      <v-card-text>
        {{ $t('valuelist.deleteDialog.valuelist.text', [valuelistNames]) }}
      </v-card-text>
      <v-card-actions>
        <v-btn color="blue darken-1" text @click="close">{{ $t('app.btn.cancel') }}</v-btn>
        <v-btn color="blue darken-1" text @click="deleteList">{{ $t('app.btn.yes') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import {mapActions, mapMutations} from "vuex";

export default {
  name: "deleteDialog",

  data() {
    return {
      dialog: false,
      valuelists: []
    }
  },
  computed: {
    valuelistNames: function () {
      return this.valuelists.map(v => v.name).join(",")
    }
  },
  methods: {
    open(valuelists) {
      this.valuelists = valuelists
      this.dialog = true;
    },
    async deleteList() {
      const failedNames = []
      for (const valuelist of this.valuelists) {
        const success = await this.deleteValueList(valuelist);
        if (!success) failedNames.push(valuelist.name)
      }
      const allSuccessful = failedNames.length === 0

      if (allSuccessful) {
        this.onNotification({
          message: this.$t('valuelist.deleteDialog.success.delete.valuelist', [this.valuelistNames]),
          color: 'success'
        });
      } else {
        console.error(`The valuelists ${failedNames} could not be deleted`)
        this.onNotification({
          message: this.$t('valuelist.deleteDialog.error.delete.valuelist', [failedNames]),
          color: 'error'
        });
      }

      this.$emit('input', allSuccessful);
      this.close();
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        Object.assign(this.valuelist, {});
      });
    },
    ...mapMutations({
      onNotification: 'snackbar/onNotification'
    }),
    ...mapActions({
      deleteValueList: 'valuelist/deleteValueList'
    })
  },

}

</script>

<style scoped>

</style>